import {
  DownloadResultManager,
  ServiceUsingCountManager,
} from "@/services/license/base/license-manager-abstractions";
import { ConvertUsingCountLimiter } from "@/services/license/license-limiters/service-using-count-limiters/convert-using-count-limiter";
import { DefaultDownloadResultLimiter } from "@/services/license/license-limiters/download-result-limiters/default-download-result-limiter";
import { ConvertBaseLicenseManager } from "@/services/license/base/convert-base-license-manager";

export const TRIAL_CONVERT_RESULT_LIMIT_SECS = 15;

export class ConvertVoiceLicenseManager
  extends ConvertBaseLicenseManager
  implements ServiceUsingCountManager, DownloadResultManager
{
  serviceUsingCountLimiter = new ConvertUsingCountLimiter();
  downloadResultLimiter = new DefaultDownloadResultLimiter();
}

const convertVoiceLicenseManager = new ConvertVoiceLicenseManager();
export { convertVoiceLicenseManager };
